// Import Packages
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Import Helper
import { CheckIfFlowUpdated } from "../../../../../helpers/helper";

// Import Material UI
import { Select, MenuItem, Box } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";

// Import Pages
import { TextInput } from "../../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { CredentialPicker } from "../../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker";
import FieldLabel from '../../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// Import Recoil
import { changedFields, initialActions, saveAvailable } from "../../../../../recoil-store/recoil-state";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { FileInputMateDrive } from "../../../../FlowConfigurationInputs";

function TabPanel({ children, value, index }) {
    return <div>{value === index && <Box>{children}</Box>}</div>;
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function AuthenticationType({ action, variables, setOpenVariable, serverType, isTabChanged, automId, showAlert }) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.FTP-SFTP.CONNECT.";
    const [authenticationType, setAuthenticationType] = useState("anonymous");
    const [transferType, setTransferType] = useState("binary");
    const [fileChooseTab, setFileChooseTab] = useState(0);

    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    const options = {
        fileInput: {
            checkExtension: (ext) => {
                if (ext.toLocaleLowerCase() !== 'key' && ext.toLocaleLowerCase() !== 'pem') {
                    showAlert(t(label + 'UPLOAD_PRIVATE_KEY_FILE_ONLY'));
                    return false;
                }
                return true;
            },
            fileType: '.key, .pem'
        }
    }

    useEffect(() => {
        if (serverType === "ftp" || serverType === "ftps") {
            if (action.fields.authenticationType?.value) {
                setAuthenticationType(action.fields.authenticationType.value)
            }
        } else {
            if (action.fields.authenticationType?.value) {
                setAuthenticationType(action.fields.authenticationType.value)
            }
        }
    }, []);
    useEffect(() => {
        if (isTabChanged) {
            if (serverType === "ftp" || serverType === "ftps") {
                action.fields.authenticationType = { value: "anonymous" }
                setAuthenticationType("anonymous")
            } else {
                action.fields.authenticationType = { value: "key_uname" }
                setAuthenticationType("key_uname")
            }
        }
    }, [serverType]);

    useEffect(() => {
        if (!action.fields.fileType) {
            action.fields.fileType = { value: "FILE" };

        } else {
            if (action.fields.fileType?.value === "FILE") {
                setFileChooseTab(0);
            } else {
                setFileChooseTab(1)
            }
        }
    }, [action.id])

    const handleClick = (e) => {
        let value = e.target.value;

        const field = initialActionsData[action.id]?.fields["authenticationType"];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated("authenticationType", action, oldValue, value, setSaveAvailable, setChangeFields, changedFieldsState);
        if (value === "anonymous") {
            delete action.fields.loginPass
            delete action.fields.loginUser
        }
        if (serverType === "sftp") {
            if (value === "credentials") {
                delete action.fields.filePath
            }
            else if (value === "key_uname") {
                delete action.fields.loginPass
                delete action.fields.loginPassword
            }
        }
        action.fields.authenticationType = { value };
        setAuthenticationType(value);
    };

    const handleChange = (e, type) => {
        if (type === "transferType") {
            setTransferType(e.target.value)
        }
    }

    const handleChangeTabs = (newValue) => {
        if (newValue === 1) {
            // action.fields.filePath.type = 'TEXT';
            action.fields.fileType.value = 'TEXT';
            action.fields.filePath.backup = { value: action.fields.filePath.value };
            action.fields.filePath.value = "";
            if (action.fields.filePath.backupText?.value) {
                action.fields.filePath.value = action.fields.filePath.backupText.value;
            }
        } else {
            // action.fields.filePath.type = 'FILE';
            action.fields.fileType.value = 'FILE';

            action.fields.filePath.backupText = { value: action.fields.filePath.value }
            delete action.fields.filePath.value
            if (action.fields.filePath.backup?.value) {
                action.fields.filePath.value = action.fields.filePath.backup.value;
            }
        }
        const field = initialActionsData[action.id]?.fields.fileType;
        const oldValue = !field ? undefined : field.value;
        let v = newValue === 1 ? 'TEXT' : 'FILE';
        CheckIfFlowUpdated("fileType", action, oldValue, v, setSaveAvailable, setChangeFields, changedFieldsState);
        setFileChooseTab(newValue);
    }

    return (
        <div className="child-section-container">
            {(serverType === 'ftp' || serverType === 'ftps') && (
                <div className="conf-field-container condition-tabs">
                    <FieldLabel name={t(label + "AUTHENTICATION-TYPE")} />
                    <button className={authenticationType === 'anonymous' ? 'condition-active' : ''}
                        value="anonymous" onClick={handleClick}>
                        {t(label + 'ANONYMOUS')}
                    </button>
                    <button className={authenticationType === 'uname_pass' ? 'condition-active' : ''}
                        value="uname_pass" onClick={handleClick}>
                        {t(label + 'USERNAME-PASSWORD')}
                    </button>
                </div>
            )}
            {serverType === 'sftp' && (
                <div className="conf-field-container condition-tabs">
                    <FieldLabel name={t(label + "AUTHENTICATION-TYPE")} />
                    <button className={authenticationType === 'key_uname' ? 'condition-active' : ''}
                        value="key_uname" onClick={handleClick}>
                        {t(label + 'KEY-USERNAME')}
                    </button>
                    <button className={authenticationType === 'key_credentials' ? 'condition-active' : ''}
                        value="key_credentials" onClick={handleClick}>
                        {t(label + 'KEY-CREDENTIALS')}
                    </button>
                    <button className={authenticationType === 'credentials' ? 'condition-active' : ''}
                        value="credentials" onClick={handleClick}>
                        {t(label + 'CREDENTIALS')}
                    </button>
                </div>
            )}
            {authenticationType === 'uname_pass' && (
                <>
                    <div className="conf-field-container">
                        <FieldLabel name={t(label + "USER")} is_required={true} />
                        <CredentialPicker
                            action={action}
                            inputName="loginUser"
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            isRequired={true}
                            hideRequired={true}
                        />
                    </div>
                    <div className="conf-field-container">
                        <FieldLabel name={t(label + "PASSWORD")} is_required={true} />
                        <CredentialPicker
                            action={action}
                            inputName="loginPass"
                            variables={variables}
                            setOpenVariable={setOpenVariable}
                            isRequired={true}
                            isPassword={true}
                            hideRequired={true}
                        />
                    </div>
                </>

            )}
            {(authenticationType === 'anonymous' || (authenticationType === 'uname_pass' && serverType === "ftp")) && (

                <RadioGroup value={transferType}
                    onChange={(e) => {
                        handleChange(e, 'transferType');
                    }}>
                    <div className="conf-field-container">
                        <FieldLabel name={t(label + "TRANSFER-TYPE")} is_required={true} />
                        <div>
                            <FormControlLabel
                                value="binary" label={t(label + 'BINARY')}
                                control={<Radio color="default" size="small" />}
                            />
                        </div>
                        <div>
                            <FormControlLabel
                                value="ascii" label="ASCII"
                                control={<Radio color="default" size="small" />}
                            />
                        </div>
                    </div>
                </RadioGroup>
            )}
            {authenticationType === 'anonymous' && serverType === 'ftp' && (
                <div className="conf-field-container">
                    <FieldLabel name={t(label + "DEFAULT-DIRECTORY-PATH")} is_required={false} />
                    <TextInput
                        action={action}
                        inputName="defaultDirectoryPath"
                        variables={variables}
                        setOpenVariable={setOpenVariable}
                        isRequired={false}
                    />
                    <small
                        className="conf-field-desc"><em>{t(label + 'DEFAULT-DIRECTORY-PATH-HELP')}</em></small>
                </div>
            )}
            {(authenticationType === 'key_uname' || authenticationType === 'key_credentials') && (
                <div className="conf-field-container">
                    <FieldLabel name={t(label + "PRIVATE-KEY-FILE")} is_required={true} />
                    <div className="condition-tabs" style={{ marginBottom: 5 }}>
                        <button
                            className={`f-s-11 ${fileChooseTab === 0 ? 'condition-active' : ''}`}
                            onClick={() => handleChangeTabs(0)}>
                            {t(label + 'SELECT-FILE')}
                        </button>
                        <button
                            className={`f-s-11 ${fileChooseTab === 1 ? 'condition-active' : ''}`}
                            onClick={() => handleChangeTabs(1)}>
                            {t(label + 'CUSTOM-STRING')}
                        </button>
                    </div>
                    <TabPanel value={fileChooseTab} index={0}>
                        <FileInputMateDrive action={action} inputName="filePath" options={options.fileInput}
                            isRequired
                            isSize={true} clear={true} hideRequired autom_id={automId} />
                    </TabPanel>
                    <TabPanel value={fileChooseTab} index={1}>
                        <TextInput action={action} inputName="filePath" isRequired={true}
                            setOpenVariable={setOpenVariable} hideRequired={true}
                            variables={variables} autom_id={automId} />
                    </TabPanel>
                </div>
            )}
            {(authenticationType === 'key_uname' || authenticationType === 'key_credentials' || authenticationType === 'credentials') && (
                <div className="conf-field-container">
                    <FieldLabel name={t(label + "USER")} is_required={true} />
                    <CredentialPicker
                        action={action}
                        inputName="loginUser"
                        variables={variables}
                        setOpenVariable={setOpenVariable}
                        isRequired={true}
                        hideRequired={true}
                    />
                </div>
            )}
            {(authenticationType === 'key_credentials' || authenticationType === 'credentials') && (
                <div className="conf-field-container">
                    <FieldLabel name={t(label + "PASSWORD")} is_required={true} />
                    <CredentialPicker
                        action={action}
                        inputName="loginPass"
                        variables={variables}
                        setOpenVariable={setOpenVariable}
                        isRequired={true}
                        isPassword={true}
                        hideRequired={true}
                    />
                </div>
            )}
        </div>
    );
}

export default AuthenticationType;